import React, { Component } from "react"
export default class Loading extends Component {
  render() {
    var style = this.props.style || {}
    style.minHeight = 350
    return (
      <div className="load-9" style={style}>
        <div className="spinner">
          <div className="bubble-1" />
          <div className="bubble-2" />
        </div>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/Loading.js